import Icon from '@passkeys/ui/icon';
import Text from '@passkeys/ui/text';
import { useCallback, useMemo } from 'react';

import type { ActivityItem } from '@/ui/flux/tx-log/types';
import useAssets from '@/ui/hooks/use-assets';
import { openInBlankWindow } from '@/ui/utils/navigation';

type FooterProps = {
  activityItem?: ActivityItem;
};

function Footer({ activityItem }: FooterProps) {
  const order = activityItem?.order;

  const assets = useAssets();
  const assetName = useMemo(() => {
    if (order?.toTxId) {
      return order.toAsset;
    }

    return order?.fromTxId ? order.fromAsset : activityItem?.assetName;
  }, [activityItem, order]);
  const asset = assetName ? assets[assetName] : undefined;

  const txId = useMemo(
    () => order?.toTxId ?? order?.fromTxId ?? activityItem?.txId,
    [activityItem, order],
  );

  const handleViewOnExplorerClick = useCallback(async () => {
    if (!asset || !txId) {
      return;
    }

    const url = await asset.baseAsset.blockExplorer.txUrl(txId);
    openInBlankWindow(url);
  }, [asset, txId]);

  if ((order && !order.toTxId) || !txId) {
    return null;
  }

  return (
    <footer className="my-6 flex flex-col items-center justify-center text-center">
      <Text size={14} className="text-black/40 theme-dark:text-neutral-400">
        See the status on the web:
      </Text>
      <button
        className="inline-flex h-10 items-center justify-center gap-x-2 font-mono text-xs font-medium uppercase leading-none text-black theme-dark:text-white"
        onClick={handleViewOnExplorerClick}
        type="button"
        data-testid="view-on-explorer-button"
      >
        View on explorer
        <Icon name="arrow-up-right" size={12} />
      </button>
    </footer>
  );
}

export default Footer;
